import React, { Component } from 'react';
import { Link } from 'react-router-dom'

import 'bootstrap/dist/css/bootstrap.min.css';
import './App.scss';
import opening from './img/WobblyABC/openingscreen.png';
import beeabc from './img/WobblyABC/beeabc.png';
import bubbleabc from './img/WobblyABC/bubbleabc.png';
import starabc from './img/WobblyABC/starabc.png';
import appstorebadge from './img/Download_on_the_App_Store_Badge_US-UK_RGB_blk_092917.svg';


class WobblyABC extends Component {

	componentDidMount() {
    const script = document.createElement("script");

    script.src = "https://apis.google.com/js/platform.js";
    script.async = true;

    document.body.appendChild(script);
  }


	render(){
	return (
		<div className="container-fluid appdesc corners">
 	<div className="row padrow">
 	  <div className="col-md-8 col-lg-8 centername">
           <h2>Wobbly ABC</h2>
 	  </div>

       <div className="col-md-4 col-lg-4 centername">
	   <div className="badgecontainer">
		 <a href='https://apps.apple.com/app/id1542427817'><img src={ appstorebadge } alt="Get in on App Store Badge" className="applebadge img-responsive d-block mx-auto badge"/></a>
</div>
     </div>
 	</div>
	<div className="row padrow">
	<div className="col-md-12 col-lg-12 centervideo">
	 <iframe width="560" height="315" src="https://www.youtube.com/embed/cdh2a8DGzZU" frameborder="2" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
	</div>
	</div>
	 <div className="row padrow">
	 <div className="col-md-12 col-lg-12 youtube">

	 <a href='https://www.youtube.com/channel/UC4eN-brmGnxMLAYw3N5tA_g?view_as=subscriber?sub_confirmation=1'><b>Subscribe to YouTube Channel!</b>

	 </a>
	</div>
	</div>
 	 <div className="row padrow">
  <div className="col-md-12 col-lg-12">
           Is your child fascinated by the alphabet?  Engage his fine motor skills with this fun alphabet centric game.  Each alphabet letter flies through the screen until dragged into its proper place.
           </div>
 	  </div>
 	  <div className="row padrow">
 	  <div className="col-md-12 col-lg-12">
           <img src={opening} alt="Opening screen of WobblyABC Application" className="appimage img-responsive img-thumbnail d-block mx-auto readypic"/>
 	 </div>

 	  </div>



           <div className="row padrow">
 	  <div className="col-md-12 col-lg-12">
 	  Three fun alphabets to choose from:
           </div>
 	  </div>
           <div className="row padrow">
           <div className="col-md-4 col-lg-4">
            <img src={beeabc} alt="Bee ABC" className="appimage img-responsive img-thumbnail d-block mx-auto readypic"/>
 	  </div>
 	  <div className="col-md-4 col-lg-4">
            <img src={starabc} alt="Star ABC" className="appimage img-responsive img-thumbnail d-block mx-auto readypic"/>
 	  </div>
    <div className="col-md-4 col-lg-4">
            <img src={bubbleabc} alt="Bubble ABC" className="appimage img-responsive img-thumbnail d-block mx-auto readypic"/>
 	  </div>
           </div>




           <div className="row padrow">
 	  <div className="col-md-12 col-lg-12">
    After each round, the speed of the alphabet increases to gradually increase difficulty. Frustrated?  Just restart!!
 	  Let us <Link to="/feedback" >
		know
		</Link> if you have any comments, or if there is someway we can make this app more useful to you.  Of course, also let us know if you experience any glitches.  We look forward to hearing from you!
          </div>

 	  </div>
 	</div>


);
		}

}

export default WobblyABC;
